import React from 'react';

interface SpeakerToggleProps {
  isSpeaker: boolean;
  talkCount: number;
  isEditing: boolean;
  onChange: (enabled: boolean) => void;
}

const SpeakerToggle: React.FC<SpeakerToggleProps> = ({
  isSpeaker,
  talkCount,
  isEditing,
  onChange
}) => {
  const showWarning = talkCount > 0 && !isSpeaker;

  return (
    <div className="mb-4">
      <div className="form-check">
        <input
          className="form-check-input"
          type="checkbox"
          id="speakerToggle"
          checked={isSpeaker}
          onChange={(e) => onChange(e.target.checked)}
          disabled={!isEditing}
        />
        <label className="form-check-label fw-bold" htmlFor="speakerToggle">
          I'm a speaker
        </label>
      </div>
      <small className="text-muted ms-4">
        Enable this to appear in speaker search results and be discoverable by event organizers
      </small>

      {showWarning && (
        <div className="alert alert-warning mt-2 mb-0" role="alert">
          <i className="fas fa-exclamation-triangle me-2"></i>
          <strong>Notice:</strong> You have {talkCount} talk{talkCount !== 1 ? 's' : ''} listed but your speaker toggle is disabled.
          Enable it to appear in speaker search results.
        </div>
      )}
    </div>
  );
};

export default SpeakerToggle;
